import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { fetchFinSobSidePanelSettings } from '../../../services/finSobSidePanel/fetchFinSobSidePanelSettings'
import { REQUEST_FIN_SOB_SIDE_PANEL_SETTINGS } from '../constants'

export const requestFinSobSidePanelSettings = createAsyncThunk(
  REQUEST_FIN_SOB_SIDE_PANEL_SETTINGS,
  fetchFinSobSidePanelSettings
)
